
import { defineComponent, ref } from 'vue'
import { store } from '@/store'

export default defineComponent({
  name: 'GiveFeedback',
  setup() {
    const msg = ref('')
    const loading = ref(false)
    const sent = ref(false)

    async function give() {
      if (msg.value) {
        loading.value = true
        await store.user.giveFeedback(msg.value)
        sent.value = true
      }
    }

    function close() {
      store.modal.hideModal('GiveFeedback')
    }

    return { store, give, msg, loading, sent, close }
  }
})
